import React from 'react';
import { useNavigate } from 'react-router-dom';

import { MailOutline } from '@mui/icons-material';
import { Button, Typography } from '@mui/material';

import { gray100, primaryButtonOutlinedColor } from '../../../constants/Colors';
import { headerHeight, spHeaderHeight } from '../../../constants/Location';
import Header from '../../uiParts/Header';
import CustomHead from '../CustomHead';

const styles = {
  checkIcon: {
    '@media screen and (max-width:600px)': {
      fontSize: '64px'
    },
    fontSize: '80px',
    width: '100%'
  },
  container: {
    '@media screen and (max-width:600px)': {
      height: `calc( 100vh  - ${spHeaderHeight} - 64px)`,
      m: `${spHeaderHeight} auto 0`,
      pt: '64px',
      width: '90%'
    },
    height: `calc( 100vh - ${headerHeight} - 96px )`,
    m: `${headerHeight} auto 0`,
    pt: '96px',
    width: '560px'
  },
  text: {
    color: gray100,
    mt: '24px',
    textAlign: 'center'
  },
  primaryButtonOutlinedColor,
  title: {
    color: gray100,
    fontSize: '24px',
    fontWeight: '500',
    mt: '16px',
    textAlign: 'center'
  }
};

const AuthRegisterSent: React.FC = () => {
  const navigate = useNavigate();

  return (
    <>
      <CustomHead title="会員登録メール送信 | CMCOS[コムコス]" />
      <Header />
      <Typography component="div" sx={styles.container}>
        <MailOutline sx={styles.checkIcon} />
        <Typography sx={styles.title}>
          ご登録メールアドレスに
          <br />
          認証メールを送信しました
        </Typography>
        <Typography sx={styles.text}>
          まだ会員登録は完了しておりません。
          <br />
          メールに記載されているURLをクリックして、認証を完了してください。
          <br />
          メール送信時点から24時間以内にお手続きください。
        </Typography>
        <Button
          fullWidth
          onClick={() => navigate('/auth/register')}
          sx={[styles.primaryButtonOutlinedColor, { mt: '80px' }]}
          variant="outlined"
        >
          戻る
        </Button>
      </Typography>
    </>
  );
};

export default AuthRegisterSent;
